import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { ArcFormula, ArcSearch, ArcService } from 'src/app/revenue/shared/arc';
import { ArbService } from 'src/app/revenue/shared/billing/arb.service';
import { BillingCycleEnum } from 'src/app/revenue/shared/billing/dto/arb-read.dto';
import { RevenueItemSearchDto } from 'src/app/revenue/shared/revenue-items/dto/revenue-item-search.dto';
import { RevenueItem } from 'src/app/revenue/shared/revenue-items/revenue-item.model';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { PurchaseItemMetadataLego } from '../../shared/dto/purchase-item-metadata.lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-purchase-item-lego-edit',
  templateUrl: './purchase-item-lego-edit.component.html',
  styleUrls: ['./purchase-item-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class PurchaseItemLegoEditComponent implements OnInit, OnChanges {
  @Input() purchaseItemData: PurchaseItemMetadataLego;
  revenueItemOptions: Array<SelectItem>;
  allRevenueItems: Array<RevenueItem>;
  revenueItemArcs: Array<Array<ArcFormula>> = [];
  revenueItemArcOptions: Array<SelectItem>;
  revenueItemArbOptions: Array<SelectItem>;
  useArcDisabled: boolean = false;
  useArbDisabled: boolean = false;
  billingCycleEnum = BillingCycleEnum;

  constructor(private _revenueItemService: RevenueItemService, private _arcService: ArcService, _arbService: ArbService) {}

  ngOnInit(): void {
    this.revenueItemArbOptions = Object.keys(this.billingCycleEnum)
      .filter((x) => isNaN(Number(x)) && x != 'None')
      .map((val) => {
        return { label: val, value: this.billingCycleEnum[val] };
      });
    this._revenueItemService
      .searchRevenueItems({ Inactive: false, PageNumber: 0, PageSize: 0, OrderBy: 'ItemName:asc' } as RevenueItemSearchDto)
      .then((data) => {
        this.allRevenueItems = data.Result;
        this.revenueItemOptions = data.Result.map((x) => {
          return { label: x.ItemName, value: x.ItemNum } as SelectItem;
        });
        this.revenueItemChanged();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // older forms have this field already populated with 0, which is wrong. killit.
    if (changes.purchaseItemData && this.purchaseItemData.BillingCycle == BillingCycleEnum.None) {
      this.purchaseItemData.BillingCycle = null;
    }
  }

  revenueItemChanged() {
    this.useArcDisabled = false;
    if (this.purchaseItemData?.RevenueItemNum) {
      this.purchaseItemData.RevenueItemName = this.allRevenueItems.find((x) => x.ItemNum == this.purchaseItemData.RevenueItemNum)?.ItemName;

      if (this.revenueItemArcs[this.purchaseItemData.RevenueItemNum] === undefined) {
        let arcSearch = new ArcSearch();
        arcSearch.ItemNum = this.purchaseItemData.RevenueItemNum;
        this._arcService.searchArcs(arcSearch).then((arcs) => {
          this.revenueItemArcs[this.purchaseItemData.RevenueItemNum] = arcs.Result;
          this.mapArcSelectItems();
          this.validateArc();
        });
      } else {
        this.mapArcSelectItems();
        this.validateArc();
      }
    }
  }

  mapArcSelectItems() {
    this.revenueItemArcOptions = [];

    if (this.revenueItemArcs[this.purchaseItemData.RevenueItemNum]?.length >= 1) {
      this.revenueItemArcOptions = this.revenueItemArcs[this.purchaseItemData.RevenueItemNum].map((arc) => {
        return { label: arc.Descr, value: arc.ArcID } as SelectItem;
      });
    }
  }

  validateArc() {
    if (this.revenueItemArcs[this.purchaseItemData.RevenueItemNum]?.length === 1) {
      this.purchaseItemData.ArcId = this.revenueItemArcs[this.purchaseItemData.RevenueItemNum][0].ArcID;
    }
    if (this.revenueItemArcs[this.purchaseItemData.RevenueItemNum]?.length === 0) {
      this.purchaseItemData.UseArc = false;
      this.useArcDisabled = true;
    }
  }
}
